const EXTERNAL_LINK_PREFIXES = [
    'https://',
    'http://localhost:8080',
    'mailto:'
];
export class DiscordLinkInterceptor {
    static isExternalLink(url) {
        return EXTERNAL_LINK_PREFIXES.some((prefix)=>url.startsWith(prefix));
    }
    static getElementHref(clickedElement) {
        var _clickedElement_closest;
        if (clickedElement == undefined) return;
        if (clickedElement.getAttribute('id') == 'store-href') return '/store';
        return (_clickedElement_closest = clickedElement.closest('a')) === null || _clickedElement_closest === void 0 ? void 0 : _clickedElement_closest.getAttribute('href');
    }
    init() {
        this.overrideWindowOpen();
        document.addEventListener('click', (event)=>this.interceptLinkClicks(event));
    }
    openExternalLink(url) {
        this.openExternalLinkHandler(url);
    }
    overrideWindowOpen() {
        const originalWindowOpen = window.open;
        window.open = (url, target, features)=>{
            var _this_handleInternalNavigation, _this;
            const urlString = url != undefined ? String(url) : '';
            if (DiscordLinkInterceptor.isExternalLink(urlString)) {
                this.openExternalLink(urlString);
                return null;
            }
            if ((_this_handleInternalNavigation = (_this = this).handleInternalNavigation) === null || _this_handleInternalNavigation === void 0 ? void 0 : _this_handleInternalNavigation.call(_this, urlString)) return null;
            return originalWindowOpen.call(window, url, target, features);
        };
    }
    interceptLinkClicks(event) {
        const clickedElement = event.target;
        const href = DiscordLinkInterceptor.getElementHref(clickedElement);
        if (!href) return;
        if (DiscordLinkInterceptor.isExternalLink(href)) {
            event.preventDefault();
            this.openExternalLink(href);
            return;
        }
        if (this.handleInternalNavigation == undefined) return;
        if (this.handleInternalNavigation(href)) event.preventDefault();
    }
    constructor(openExternalLink, handleInternalNavigation){
        this.openExternalLinkHandler = openExternalLink;
        this.handleInternalNavigation = handleInternalNavigation;
    }
}
